
const TonsPage = (props) => {

    const setValue = () => {
        let userInput = document.getElementById('tons-input')
        props.userInputValue(userInput.value)
    }
    
    return(
        <div className="h-100">
            <div className="row space-between">
                <div className="right-third">
                    <h1 className="title-text mb-1">How many metric tons of carbon would your company like to offset?</h1>
                    <div className="row flex-start">
                        <div className="input-rect mr-1">
                            <input 
                                type="number"
                                id='tons-input'
                                className="number-input"
                                ></input>
                            <p id="mt">t</p>
                        </div>
                        <div>
                            <button className="pointer" onClick={()=> {
                                props.setPage('almostThere')
                                setValue()
                                }}>Submit</button>
                            <p className="f-12 f-yellow pointer" onClick={()=> props.setPage('home')}>Or choose another way</p>
                        </div>
                    </div>
                </div>
                <div className="sign-conntainer">
                    <div className="sign-top"></div>
                    <div className="sign">
                        <div className="col space-around">
                            <h3 className="f-16 m-0">Tip:</h3>
                            <p className="f-16 m-0">1 metric ton (t) is approximately 2,205 pounds of carbon (CO2).</p>
                            <br></br>
                        </div>
                    </div>
                </div>
            </div>
            <div className="align-end mt-5">

                <p className="f-14 f-gray">Change your mind? Choose a different way to get involved.</p>
                <div className="row space-between ">
                    <div className="f-yellow f-12 f-c">
                        METRIC TONS
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('dollars')}>
                        DOLLARS INVESTED
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('watts')}>
                        NEW SOLAR WATTS
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TonsPage;